/** @format */

import { useEffect, useRef, useState } from "react";
import { useHistory } from "../../router/useHistory";
import { BsBell } from "react-icons/bs";
import { FaBell } from "react-icons/fa";
import { MdOutlineArrowBackIos, MdOutlineArrowForwardIos } from "react-icons/md";
import { connect, useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import MenuIcon from "../../assets/images/menuIcon.svg";
import logo from "../../assets/images/tamam-logo-new.svg";
import { TEXT_DIRECTION } from "../../helper/helperFunctions";
import I18n, { i18n } from "../../pages/private/languageSelector";
import { changeCurrentRole, getSession } from "../../redux/reducers/authentication/authentication";
import { getForm, getForms, patchForm, patchFormForNotification } from "../../redux/reducers/form/form.reducer";
import { getAllNotifications } from "../../redux/reducers/notifications/notifications.reducer";
import SubscriptionCustomToast from "../dialogs/SubscriptionCustomToast";

const HeaderBar = ({
  patchFormForNotification,
  newForm,
  storedOldForm,
  setCollapsed,
  toggleNavbar,
  allNotifications,
  collapsed,
  user,
  setOpenNotification,
  currentRoute,
  id,
  openNotification,
  getAllNotifications,
  allForms,
  unreadCount,
}) => {
  const location = useLocation();
  const [successLoading, setSuccessLoading] = useState(false);
  let language = user?.language;

  const path =
    location.pathname.includes("/management/users/") ||
    location.pathname.includes("/management/subscriptions/update-plan") ||
    location.pathname.includes("/management/sites/add") ||
    location.pathname.includes("/reports/my-reports/edit/") ||
    location.pathname.includes("/management/sites/") ||
    location.pathname.includes("/start/") ||
    location.pathname.includes("/homepage") ||
    location.pathname.includes("/terms-and-conditions") ||
    location.pathname.includes("/privacy-policy") ||
    location.pathname.includes("/forms/form-management/dispatch/") ||
    currentRoute?.enableBack;

  const hiddenHeaderBar =
    location.pathname.includes("/start/") ||
    location.pathname.includes("setup-account") ||
    location.pathname.includes("/report-pdf-view") ||
    location.pathname.includes("/homepage") ||
    location.pathname.includes("/terms-and-conditions") ||
    location.pathname.includes("/privacy-policy") ||
    (currentRoute?.step1 === undefined &&
      location.pathname.includes("/forms/form-management") &&
      !location.pathname.includes("/forms/form-management/dispatch"));
  location.pathname.includes("/password-reset-message-email");

  const hideNotification =
    location.pathname.includes("/update-plan") ||
    location.pathname.includes("/homepage") ||
    location.pathname.includes("/terms-and-conditions") ||
    location.pathname.includes("/privacy-policy") ||
    (location.pathname.includes("forms/form-management") && currentRoute?.enableBack);

  let wrapperRef = useRef();
  const history = useHistory();

  useEffect(() => {
    if (id) {
      let selectedForm = allForms?.find((item) => item?.id === id);
      if (selectedForm && !selectedForm.isFormSame) {
        localStorage.setItem("showSuccessMessage", true);
      } else {
        localStorage.setItem("showSuccessMessage", false);
      }
    }
  }, [allForms, id, allNotifications, successLoading]);

  const toggleNavbarSave = () => {
    if (currentRoute?.enableBack) {
      handleFormUpdate();

      if (currentRoute.step2 === "Form Management" || currentRoute.step2 === i18n("Form.Forms-List")) {
        history.push("/forms/form-management");
        if (localStorage.getItem("showSuccessMessage") === "true") {
          setTimeout(() => {
            SubscriptionCustomToast(i18n("Toast.SavedSuccessfully"));
          }, 500);
        }
      } else if (currentRoute.step2 === "Global List" || currentRoute.step2 === i18n("Table.Responses")) {
        history.push("/forms/global-list");
      } else if (currentRoute.step2 === "Archive" || currentRoute.step2 === i18n("Reports.Archive")) {
        history.push("/forms/archive");
      } else if (currentRoute.step2 === "Library" || currentRoute.step2 === i18n("global.Library")) {
        history.push("/forms/library");
      }
    }
  };
  function useOutsideAlerter(ref, collapsed, setCollapsed) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref && ref?.current && !ref?.current?.contains(event.target)) {
          if (!collapsed) {
            setCollapsed(true);
          }
        }
      }
      if (id?.length) {
        localStorage.setItem("formId", id);
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, collapsed, setCollapsed]);
  }

  useOutsideAlerter(wrapperRef, collapsed, setCollapsed);

  const handleSaveAndBackClick = () => {
    if (location.pathname.includes("/management/users/")) {
      history.push("/management/users");
    } else if (location.pathname.includes("/management/subscriptions/update-plan")) {
      history.push("/management/subscriptions");
    } else if (location.pathname.includes("/reports/my-reports/edit/")) {
      history.push("/reports/my-reports");
    } else if (location.pathname.includes("/management/sites/add")) {
      history.push("/management/sites");
    } else if (location.pathname.includes("/forms/form-management/dispatch/")) {
      history.push("/forms/form-management");
    } else if (location.pathname.includes("/management/sites/")) {
      history.push("/management/sites");
    }
  };

  // const dispatch = useDispatch();
  // const liveFormDraft = useSelector((state) => state.form.liveFormDraft);

  const handleFormUpdate = async () => {
    setSuccessLoading(true);
    try {
      const formId = localStorage.getItem("formId");
      await patchFormForNotification(formId, {
        oldForm: storedOldForm,
        newForm: newForm,
      });

      localStorage.setItem("isEditOpen", null);

      await getForms({
        limit: 10,
        page: 1,
        sortBy: "updatedAt:desc",
        isArchived: false,
      });
      await getAllNotifications();
      setSuccessLoading(false);
    } catch (error) {
      console.error("Error updating form:", error);
    }
  };

  return (
    <>
      {!hiddenHeaderBar && (
        <div className={`w-full items-center h-12 flex justify-between bg-white px-3 fixed ${!openNotification ? "z-50" : ""} `}>
          {currentRoute?.enableBack && (
            <div>
              <button onClick={toggleNavbarSave} className="focus:outline-none">
                <small style={{ marginLeft: "0.5rem" }} className="flex text-colPrimary font-medium">
                  <div className="flex">
                    <I18n lng="global.Save" />
                    <span className="mx-1">&</span>
                    <I18n lng="global.Back" />
                  </div>
                </small>
              </button>
            </div>
          )}
          {!currentRoute?.enableBack && currentRoute?.step1 && (
            <div className="flex items-center gap-2 text-sm absolute left-1/2 -translate-x-1/2">
              <span className="text-quaternary">{currentRoute.step1}</span>
              {currentRoute.step2 && (
                <>
                  <span className="text-gray-300">/</span>
                  <span className="text-[#333333] font-medium">{currentRoute.step2}</span>
                </>
              )}
            </div>
          )}
          {!path && (
            <div className=" flex items-center">
              <div
                onClick={() => {
                  toggleNavbar();
                }}
                className={` cursor-pointer`}
              >
                <img src={MenuIcon} alt="nav-toggler" style={{ marginTop: "0" }} />
              </div>
              <div>
                <div
                  className={`cursor-pointer ${TEXT_DIRECTION === "rtl" ? "mr-3" : "ml-3 "}`}
                  onClick={() => {
                    history.push("/");
                  }}
                  style={{
                    visibility: collapsed ? "hidden" : "visible",
                  }}
                >
                  <img
                    src={logo}
                    alt="Tamam Logo"
                    style={{ minWidth: "115px", width: "115px" }}
                    className={`${!collapsed && language === "ARABIC" && "mr-3"}`}
                  />
                </div>
              </div>
            </div>
          )}
          {!currentRoute?.enableBack && path && (
            <div>
              <span className="text-colPrimary lg:px-4 cursor-pointer flex items-center font-bold text-sm" onClick={handleSaveAndBackClick}>
                {language === "ARABIC" ? <MdOutlineArrowForwardIos /> : <MdOutlineArrowBackIos />}
              </span>
            </div>
          )}

          {!hideNotification && (
            <div className="flex items-center cursor-pointer" onClick={() => setOpenNotification(true)}>
              <span className="text-colPrimary text-sm">{unreadCount > 0 ? unreadCount : ""}</span>
              {unreadCount > 0 ? <FaBell className="text-red-500 text-xl cursor-pointer" /> : <BsBell size={18} />}
            </div>
          )}
        </div>
      )}
    </>
  );
};
const mapStateToProps = ({ form, authentication, notifications, subscription }) => ({
  user: authentication.user,
  currentRole: authentication.currentRole,
  storedOldForm: form.storedOldForm,
  currentRoute: authentication.currentRoute,
  rolesAccess: authentication.userRoleAccess,
  isAuthenticated: authentication.isAuthenticated,
  allNotifications: notifications.allNotifications,
  unreadCount: notifications.unreadCount,
  subscriptionData: subscription.subscriptionData,
  allForms: form.forms,
});
const mapDispatchToProps = {
  getForm,
  getForms,
  patchForm,
  getAllNotifications,
  patchFormForNotification,
  changeCurrentRole,
  getSession,
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderBar);
